import React from 'react'
import { Box, CircularProgress } from '@mui/material'

const Loading = () => {
  return (
    <Box sx={{ maxWidth: 200, mx: 'auto', mt: 10, display: 'flex', justifyContent: 'center' }}>
      <CircularProgress />
    </Box>
  )
}

export default Loading